import styled from "styled-components";

export const ThumbNailServiceContainer = styled.div`
  display: grid;
  /* grid-template-columns: repeat(3, 1fr); */
  gap: 20px;
  @media only screen and (min-width: 769px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media only screen and (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
  }

  .serviceBtnItem {
    border-radius: 20px !important;
    height: 34px !important;
    width: 80px !important;
    border: 1px solid #0971a2 !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    background-color: transparent !important;
    color: #0971a2 !important;
    font-size: 12px !important;
    @media only screen and (min-width: 769px) {
      &:hover {
        cursor: pointer;
        background-color: #0971a2 !important;
        color: #ffffffff !important;
      }
    }
  }
`;

export const ThumbNailProductsContainer = styled.div`
  display: grid;
  gap: 20px;
  @media only screen and (min-width: 769px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media only screen and (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
  }

  .serviceBtnItem {
    border-radius: 20px !important;
    height: 34px !important;
    width: 80px !important;
    border: 1px solid #0971a2 !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    background-color: transparent !important;
    color: #0971a2 !important;
    font-size: 12px !important;
    @media only screen and (min-width: 769px) {
      &:hover {
        cursor: pointer;
        background-color: #0971a2 !important;
        color: #ffffffff !important;
      }
    }

  }
`;